/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BlogModule } from './BlogModule';
import {
    BlogModuleFromJSON,
    BlogModuleFromJSONTyped,
    BlogModuleToJSON,
} from './BlogModule';
import type { DynacareModule } from './DynacareModule';
import {
    DynacareModuleFromJSON,
    DynacareModuleFromJSONTyped,
    DynacareModuleToJSON,
} from './DynacareModule';
import type { FaxModule } from './FaxModule';
import {
    FaxModuleFromJSON,
    FaxModuleFromJSONTyped,
    FaxModuleToJSON,
} from './FaxModule';
import type { SesModule } from './SesModule';
import {
    SesModuleFromJSON,
    SesModuleFromJSONTyped,
    SesModuleToJSON,
} from './SesModule';
import type { SmsModule } from './SmsModule';
import {
    SmsModuleFromJSON,
    SmsModuleFromJSONTyped,
    SmsModuleToJSON,
} from './SmsModule';
import type { StripeModule } from './StripeModule';
import {
    StripeModuleFromJSON,
    StripeModuleFromJSONTyped,
    StripeModuleToJSON,
} from './StripeModule';
import type { TwoFactorAuthenticationModule } from './TwoFactorAuthenticationModule';
import {
    TwoFactorAuthenticationModuleFromJSON,
    TwoFactorAuthenticationModuleFromJSONTyped,
    TwoFactorAuthenticationModuleToJSON,
} from './TwoFactorAuthenticationModule';

/**
 * 
 * @export
 * @interface TenantModules
 */
export interface TenantModules {
    /**
     * 
     * @type {DynacareModule}
     * @memberof TenantModules
     */
    dynacare?: DynacareModule;
    /**
     * 
     * @type {FaxModule}
     * @memberof TenantModules
     */
    fax?: FaxModule;
    /**
     * 
     * @type {SmsModule}
     * @memberof TenantModules
     */
    sms?: SmsModule;
    /**
     * 
     * @type {BlogModule}
     * @memberof TenantModules
     */
    blog?: BlogModule;
    /**
     * 
     * @type {TwoFactorAuthenticationModule}
     * @memberof TenantModules
     */
    twoFactorAuth?: TwoFactorAuthenticationModule;
    /**
     * 
     * @type {SesModule}
     * @memberof TenantModules
     */
    ses?: SesModule;
    /**
     * 
     * @type {StripeModule}
     * @memberof TenantModules
     */
    stripe?: StripeModule;
}

/**
 * Check if a given object implements the TenantModules interface.
 */
export function instanceOfTenantModules(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantModulesFromJSON(json: any): TenantModules {
    return TenantModulesFromJSONTyped(json, false);
}

export function TenantModulesFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantModules {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dynacare': !exists(json, 'dynacare') ? undefined : DynacareModuleFromJSON(json['dynacare']),
        'fax': !exists(json, 'fax') ? undefined : FaxModuleFromJSON(json['fax']),
        'sms': !exists(json, 'sms') ? undefined : SmsModuleFromJSON(json['sms']),
        'blog': !exists(json, 'blog') ? undefined : BlogModuleFromJSON(json['blog']),
        'twoFactorAuth': !exists(json, 'twoFactorAuth') ? undefined : TwoFactorAuthenticationModuleFromJSON(json['twoFactorAuth']),
        'ses': !exists(json, 'ses') ? undefined : SesModuleFromJSON(json['ses']),
        'stripe': !exists(json, 'stripe') ? undefined : StripeModuleFromJSON(json['stripe']),
    };
}

export function TenantModulesToJSON(value?: TenantModules | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dynacare': DynacareModuleToJSON(value.dynacare),
        'fax': FaxModuleToJSON(value.fax),
        'sms': SmsModuleToJSON(value.sms),
        'blog': BlogModuleToJSON(value.blog),
        'twoFactorAuth': TwoFactorAuthenticationModuleToJSON(value.twoFactorAuth),
        'ses': SesModuleToJSON(value.ses),
        'stripe': StripeModuleToJSON(value.stripe),
    };
}

